import shopifyGenericDefaults from '../shopify-generic/config.js';

const ignoreFields = shopifyGenericDefaults.ignoreFields;

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter((w) => !['FacetDialog'].includes(w.name)),
    {
      name: 'FacetDialog',
      template: 'FacetDialogVehicleSpecs',
      initCollapsed: window.Convermax.config?.facetDialogInitCollapsed ?? true,
      initExpandedFacets: ['category', 'stock'],
    },
  ],
};
